export const setBaseOptions = () => ({
  // title: {
  //   text: "Stacked Line",
  // },
  tooltip: {
    trigger: "axis",
  },
  legend: {
    // data: ["Email", "Union Ads", "Video Ads", "Direct", "Search Engine"],
  },
  grid: {
    left: "3%",
    right: "4%",
    bottom: "3%",
    containLabel: true,
  },
  toolbox: {
    // feature: {
    //   saveAsImage: {},
    // },
  },
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: ["08-11", "08-12", "08-13", "08-14", "08-15", "08-16", "08-17"],
  },
  yAxis: {
    type: "value",
  },
  series: [],
});

export const taskCompeleteEntries = [
  {
    name: "任务数",
    type: "line",
    stack: "Total",
    data: [120, 132, 101, 134, 90, 230, 210],
  },
];
export const taskTaskBurnDownEntries = [
  {
    name: "总体量",
    type: "line",
    // stack: "Total",
    data: [120, 120, 120, 120, 120, 120, 120],
  },
  {
    name: "任务剩余",
    type: "line",
    // stack: "Total",
    data: [120, 100, 80, 60, 40, 20, 0],
  },
];

export const projectDebriefingEntries = [
  {
    name: "任务总量",
    type: "line",
    // stack: "Total",
    data: [120, 120, 120, 120, 120, 120, 120],
  },
  {
    name: "已完成",
    type: "line",
    // stack: "Total",
    data: [30, 30, 30, 30, 30, 30, 30],
  },
];
